export const homeConstants = {
  SET_PLACE_IMAGE_DETAIL: "SET_PLACE_IMAGE_DETAIL",
  GET_OTP_dETAIL: "GET_OTP_dETAIL",
  GET_VERIFIED: "GET_VERIFIED",
  USER__DETAIL: "USER_DETAIL",
};
